module.exports = __webpack_public_path__ + "static/img/pcad1.49bea596.png";